import {NgModule}                          from '@angular/core';
import {CommonModule}                from '@angular/common';
import {ApCropRotationGridComponent} from './components/ap-crop-rotation-grid.component';
import {ApTranslationModule}         from '../translation/ap-translation.module';
import {ApCoreModule}                      from '../ap-core/ap-core.module';
import {ListComponent}                 from './components/list/list.component';
import {ApCropRotationHeaderComponent} from './components/header/ap-crop-rotation-header.component';
import {ApResponsiveTextModule}        from '../ap-responsive-text/ap-responsive-text.module';
import {FindSortPipe}                      from './pipes/find-sort.pipe';
import {FindSortIndexPipe}                 from './pipes/find-sort-index.pipe';
import {PopupModule}                       from '@progress/kendo-angular-popup';
import {ComboBoxModule, MultiSelectModule} from '@progress/kendo-angular-dropdowns';
import {FormsModule}                       from '@angular/forms';
import {ButtonModule, ButtonsModule}       from '@progress/kendo-angular-buttons';
import {HasChildrenPipe}                   from './pipes/has-children.pipe';
import {IdCreatorPipe}                     from './pipes/id-creator.pipe';
import {GetMappedChildrenPipe}             from './pipes/get-mapped-children.pipe';
import {GetSavingStatePipe}                from './pipes/get-saving-state.pipe';
import {ToCellValuePipe}                           from './pipes/to-cell-value.pipe';
import {InputsModule, SliderModule, TextBoxModule} from '@progress/kendo-angular-inputs';
import {SortComponent}                 from './components/header/sort/sort.component';
import {ApCropRotationFilterComponent} from './components/header/filter/ap-crop-rotation-filter.component';
import {DetailHeaderComponent}         from './components/header/detail-header/detail-header.component';
import {DetailComponent}                   from './components/list/detail/detail.component';
import {DetailFullCellComponent}           from './components/list/detail/detail-full-cell/detail-full-cell.component';
import {DetailCellComponent}               from './components/list/detail/detail-cell/detail-cell.component';
import {AllCropsPipe}                      from './pipes/all-crops.pipe';
import {ApUtilsModule}                     from '../ap-utils';
import {PagerComponent}                    from './components/pager.component';
import {CropShortnamePipe}                 from './pipes/crop-shortname.pipe';
import {DetailOffCellComponent}            from './components/list/detail/detail-off-cell/detail-off-cell.component';
import {FieldIsActivePipe}                 from './pipes/field-is-active.pipe';
import {ApDynGridsModule}                  from '../ap-dyngrids/ap-dyngrids.module';
import {ApTooltipModule}                   from '../ap-tooltip/ap-tooltip.module';
import {LoaderModule}                      from '@progress/kendo-angular-indicators';
import {SharedModule}                      from '@progress/kendo-angular-grid';
import {SVGIconModule}                     from '@progress/kendo-angular-icons';

@NgModule({
  declarations: [
    // Components
    ApCropRotationGridComponent,
    ListComponent,
    ApCropRotationHeaderComponent,
    SortComponent,
    ApCropRotationFilterComponent,
    DetailHeaderComponent,
    DetailComponent,
    DetailFullCellComponent,
    DetailCellComponent,
    // Pipes
    FindSortPipe,
    FindSortIndexPipe,
    HasChildrenPipe,
    IdCreatorPipe,
    GetMappedChildrenPipe,
    GetSavingStatePipe,
    ToCellValuePipe,
    AllCropsPipe,
    PagerComponent,
    CropShortnamePipe,
    DetailOffCellComponent,
    FieldIsActivePipe,
  ],
  imports: [
    CommonModule,
    ApTranslationModule,
    ApCoreModule,
    ApResponsiveTextModule,
    PopupModule,
    MultiSelectModule,
    InputsModule,
    FormsModule,
    ButtonModule,
    ComboBoxModule,
    TextBoxModule,
    ApUtilsModule,
    SliderModule,
    ButtonsModule,
    ApDynGridsModule,
    ApTooltipModule,
    LoaderModule,
    SharedModule,
    SVGIconModule
  ],
  providers: [],
  exports: [
    ApCropRotationHeaderComponent,
    ApCropRotationGridComponent,
  ]
})
export class ApCropRotationModule {
}
